import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Button3D } from '@/components/ui/button-3d';
import { X, Cookie, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'privacy_consent_accepted';

export function ConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted
    const hasAccepted = localStorage.getItem(CONSENT_KEY);
    if (!hasAccepted) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    setIsVisible(false);
  };

  const handleDismiss = () => {
    // Still set as accepted when dismissed (assumes implicit consent)
    localStorage.setItem(CONSENT_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom-4 duration-300 md:left-auto md:right-6 md:max-w-md">
      <div className="bg-card border border-border rounded-xl shadow-lg p-4">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 flex-shrink-0">
            <Shield className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-semibold text-sm">Privacidade e cookies</h3>
              <Button 
                variant="ghost" 
                size="icon" 
                className="h-6 w-6 -mr-2 -mt-1"
                onClick={handleDismiss}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
              Usamos cookies e tecnologias similares para melhorar sua experiência. 
              Ao continuar navegando, você concorda com nossa{' '}
              <Link 
                to="/privacy" 
                className="text-primary underline underline-offset-2 hover:text-primary/80"
              >
                Política de Privacidade
              </Link>.
            </p>
            <div className="flex gap-2 mt-3">
              <Button3D
                size="sm"
                onClick={handleAccept}
                className="flex-1"
              >
                <Cookie className="h-4 w-4 mr-2" />
                Aceitar
              </Button3D>
              <Button3D
                color="gray"
                size="sm"
                asChild
                className="flex-1"
              >
                <Link to="/privacy">Saiba mais</Link>
              </Button3D>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
